import { overEvery } from 'lodash';

import createBiMiddleware from '../middleware/bi-middleware';
import { createBi, createUouBi, hasBiToken, isNotDummyVisitorId } from './bi-helpers.js';
import * as forumsUouEvents from './forums-uou-events';
import * as forumsUsersEvents from './forums-users-events';
import * as wixlabsUsersEvents from './wixlabs-users-events';
import { getInstanceValue } from '../../common/store/instance-values/instance-values-selectors';

const extendForumsUouEvent = platformAPIs => (event, state) => ({
  member_id: (state.currentUser || {})._id,
  biToken: getInstanceValue(state, 'biToken'),
  visitor_id: platformAPIs.bi.visitorId,
  ...event,
});

export const forumsUouBiMiddleware = (platformAPIs, instanceId) =>
  createBiMiddleware({
    bi: createUouBi({
      endpoint: forumsUouEvents.endpoint,
      src: forumsUouEvents.src,
      instanceId,
    }),
    eventMap: forumsUouEvents.eventMap,
    extendEvent: extendForumsUouEvent(platformAPIs),
    shouldLogEvent: overEvery(hasBiToken, isNotDummyVisitorId),
    platformAPIs,
  });

const extendForumsUsersEvent = (event, state) => ({
  biToken: getInstanceValue(state, 'biToken'),
  ...event,
});

export const forumsUsersBiMiddleware = (platformAPIs, instanceId) =>
  createBiMiddleware({
    bi: createBi({
      endpoint: forumsUsersEvents.endpoint,
      src: forumsUsersEvents.src,
      instanceId,
    }),
    eventMap: forumsUsersEvents.eventMap,
    extendEvent: extendForumsUsersEvent,
    shouldLogEvent: hasBiToken,
    platformAPIs,
  });

const extendWixlabsUsersEvent = (event, state) => ({
  biToken: getInstanceValue(state, 'biToken'),
  ...event,
});

export const wixlabsUsersBiMiddleware = platformAPIs =>
  createBiMiddleware({
    bi: createBi({
      endpoint: wixlabsUsersEvents.endpoint,
      src: wixlabsUsersEvents.src,
    }),
    eventMap: wixlabsUsersEvents.eventMap,
    extendEvent: extendWixlabsUsersEvent,
    shouldLogEvent: hasBiToken,
    platformAPIs,
  });
